
export const customFunc = {
    func1: function (arg1, arg2) {
        alert('Hi from external custom.js func1 with args: ' + arg1 + arg2);
    },
    func2: function () {
        alert('Hi from external custom.js func2 w/o args');
    }
}

 
//export const WrapperConfig = new InjectionToken < AppConfig > (customWrapper.initializeApp());
export const customWrapper = {
    initializeApp: async function () { 
       return this.SetWrapper().then(res => {
            console.log(res);
            return res;
        });  
    },
    SetWrapper: async function () {
        var myval;
        if ('CefSharp' in window) {
            await CefSharp.BindObjectAsync({ NotifyIfAlreadyBound: true, IgnoreCache: true });
            console.log('Successfully');
            myval = onvidaWrapper;
        } else { console.log('failed'); }
        return myval;
    }
}